import PromoItemsBlock from './promoItemsBlock'

export default PromoItemsBlock
